export default __webpack_public_path__ + "static/media/netent-mono.42065d8d.svg";